var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftmenuBtIcon03On(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1321_3592)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8249 35.95C23.8166 35.1917 24.9249 34.5938 26.1499 34.1563C27.3749 33.7188 28.6583 33.5 29.9999 33.5C31.3416 33.5 32.6249 33.7188 33.8499 34.1563C35.0749 34.5938 36.1833 35.1917 37.1749 35.95C37.8555 35.1528 38.3853 34.2487 38.7645 33.2375C39.1437 32.2264 39.3333 31.1473 39.3333 30C39.3333 27.4139 38.4242 25.2118 36.6062 23.3938C34.7881 21.5757 32.586 20.6667 29.9999 20.6667C27.4138 20.6667 25.2117 21.5757 23.3937 23.3938C21.5756 25.2118 20.6666 27.4139 20.6666 30C20.6666 31.1473 20.8562 32.2264 21.2353 33.2375C21.6145 34.2487 22.1444 35.1528 22.8249 35.95ZM29.9999 31.1667C28.8527 31.1667 27.8853 30.773 27.0978 29.9855C26.3103 29.198 25.9166 28.2306 25.9166 27.0834C25.9166 25.9362 26.3103 24.9688 27.0978 24.1813C27.8853 23.3938 28.8527 23 29.9999 23C31.1471 23 32.1145 23.3938 32.902 24.1813C33.6895 24.9688 34.0833 25.9362 34.0833 27.0834C34.0833 28.2306 33.6895 29.198 32.902 29.9855C32.1145 30.773 31.1471 31.1667 29.9999 31.1667ZM29.9999 41.6667C28.386 41.6667 26.8694 41.3605 25.4499 40.748C24.0305 40.1355 22.7958 39.3042 21.7458 38.2542C20.6958 37.2042 19.8645 35.9695 19.252 34.55C18.6395 33.1306 18.3333 31.6139 18.3333 30C18.3333 28.3862 18.6395 26.8695 19.252 25.45C19.8645 24.0306 20.6958 22.7959 21.7458 21.7459C22.7958 20.6959 24.0305 19.8646 25.4499 19.2521C26.8694 18.6396 28.386 18.3334 29.9999 18.3334C31.6138 18.3334 33.1305 18.6396 34.5499 19.2521C35.9694 19.8646 37.2041 20.6959 38.2541 21.7459C39.3041 22.7959 40.1353 24.0306 40.7478 25.45C41.3603 26.8695 41.6666 28.3862 41.6666 30C41.6666 31.6139 41.3603 33.1306 40.7478 34.55C40.1353 35.9695 39.3041 37.2042 38.2541 38.2542C37.2041 39.3042 35.9694 40.1355 34.5499 40.748C33.1305 41.3605 31.6138 41.6667 29.9999 41.6667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1321_3592"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftmenuBtIcon03On);
export default __webpack_public_path__ + "static/media/leftmenu_bt_icon03_on.c6a65e35fa22e22aade53bfda04de6c0.svg";
export { ForwardRef as ReactComponent };